
import { supabase } from '@/lib/supabase';

export interface BulkPricingResult {
  unitCost: number;
  totalCost: number;
  hasBulkPricing: boolean;
  tierInfo: string | null;
}

// Helper function to calculate bulk pricing
export const calculateBulkPricing = async (
  componentType: string, 
  componentId: string, 
  quantity: number, 
  baseCost: number
): Promise<BulkPricingResult> => {
  console.log('[BulkPricing] Calculating bulk pricing for:', { componentType, componentId, quantity, baseCost });
  
  try {
    if (componentType === 'internal_line_item') {
      // Check for internal pricing tiers
      const { data: tiers, error } = await supabase
        .from('internal_pricing_tiers')
        .select('*')
        .eq('line_item_id', componentId)
        .lte('qty_min', quantity)
        .or(`qty_max.is.null,qty_max.gte.${quantity}`)
        .order('qty_min', { ascending: false })
        .limit(1);

      if (error) throw error;

      if (tiers && tiers.length > 0) {
        console.log('[BulkPricing] Found internal pricing tier:', tiers[0]);
        return {
          unitCost: tiers[0].unit_cost,
          totalCost: tiers[0].unit_cost * quantity,
          hasBulkPricing: true,
          tierInfo: `Bulk pricing: ${tiers[0].qty_min}${tiers[0].qty_max ? `-${tiers[0].qty_max}` : '+'} units`
        };
      }
    } else if (componentType === 'supplier_line_item') {
      // Check for supplier pricing tiers
      const { data: tiers, error } = await supabase
        .from('supplier_pricing_tiers')
        .select('*')
        .eq('line_item_id', componentId)
        .lte('qty_min', quantity)
        .or(`qty_max.is.null,qty_max.gte.${quantity}`)
        .order('qty_min', { ascending: false })
        .limit(1);

      if (error) throw error;

      if (tiers && tiers.length > 0) {
        console.log('[BulkPricing] Found supplier pricing tier:', tiers[0]);
        return {
          unitCost: tiers[0].unit_cost,
          totalCost: tiers[0].unit_cost * quantity,
          hasBulkPricing: true,
          tierInfo: `Bulk pricing: ${tiers[0].qty_min}${tiers[0].qty_max ? `-${tiers[0].qty_max}` : '+'} units`
        };
      }
    }

    // No bulk pricing found, use base cost
    return {
      unitCost: baseCost,
      totalCost: baseCost * quantity,
      hasBulkPricing: false,
      tierInfo: null
    };
  } catch (error) {
    console.error('[BulkPricing] Error calculating bulk pricing:', error);
    return {
      unitCost: baseCost,
      totalCost: baseCost * quantity,
      hasBulkPricing: false,
      tierInfo: null
    };
  }
};
